import { create } from 'zustand';
import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_KEY = '@boardsFeed:v1';

const initialState = {
    showAllBoards: false,
    isHydrated: false,
};

const persist = async (showAllBoards) => {
    try {
        await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify({ showAllBoards }));
    } catch {
        // silently fail
    }
};

const useBoardsFeedStore = create((set, get) => ({
    ...initialState,

    hydrate: async () => {
        if (get().isHydrated) return;
        try {
            const stored = await AsyncStorage.getItem(STORAGE_KEY);
            if (stored) {
                const parsed = JSON.parse(stored);
                if (parsed && typeof parsed.showAllBoards === 'boolean') {
                    set({ showAllBoards: parsed.showAllBoards, isHydrated: true });
                    return;
                }
            }
        } catch {
            // fall back to default
        }
        set({ isHydrated: true });
    },

    setShowAllBoards: (showAllBoards) => {
        persist(showAllBoards);
        set({ showAllBoards });
    },

    toggleShowAllBoards: () => {
        const next = !get().showAllBoards;
        persist(next);
        set({ showAllBoards: next });
    },
}));

export default useBoardsFeedStore;
